export default __webpack_public_path__ + "static/media/authImage.ce434a22.svg";